import { createContext, useContext } from "react";
import { useEffect, useState } from "react";
import { productDatas } from "../Datas/ProductDatas/ProductDatas";
import { isIncluded } from "../Datas/Functions/shareFunctions";
import { alluser } from "../Datas/ProfileDatas/alluser";
import { allOrderList } from "./../Datas/ProductDatas/OrderData";

const SiteContext = createContext();

export const useSiteData = () => {
  return useContext(SiteContext);
};

export const SiteProvider = ({ children }) => {
  const [isDark, setIsDark] = useState(localStorage.getItem("theme") || "dark");
  // Site Data section
  const [products, setProducts] = useState([]);
  const [userList, setUserList] = useState([]);
  const [reviewList, setReviewList] = useState([]);
  const [orderList, setOrderList] = useState([]);

  // converted data section
  const [categories, setCategories] = useState([]);
  const [isloading, setIsLoading] = useState(true);
  const [metaInfo, setMetaInfo] = useState({});
  const [checkoutData, setCheckoutData] = useState(null);
  // **************
  // theme section
  // **************
  useEffect(() => {
    if (isDark === "dark") document.body.classList.add("dark");
    else document.body.classList.remove("dark");
    setIsDark(localStorage.getItem("theme"));
  }, [isDark]);
  useEffect(() => {
    if (localStorage.getItem("theme") === null)
      localStorage.setItem("theme", "dark");
  }, []);

  //product loaded
  useEffect(() => {
    const newProducts = productDatas.sort((a, b) => {
      if (
        (isIncluded(a.category, "pubg") || isIncluded(a.name, "pubg")) &&
        (isIncluded(b.category, "pubg") || isIncluded(b.name, "pubg"))
      ) {
        return 0;
      } else if (isIncluded(a.category, "pubg") || isIncluded(a.name, "pubg")) {
        return -1;
      } else if (isIncluded(b.category, "pubg") || isIncluded(b.name, "pubg")) {
        return 1;
      } else {
        return 0;
      }
    });
    setProducts(newProducts);
  }, []);

  // order loaded
  useEffect(() => {
    const newProducts = allOrderList;
    setOrderList(newProducts);
  }, []);

  // **************
  //   Products & categories values
  // **************
  useEffect(() => {
    //categories section
    const newObject = productDatas?.reduce((obj, prd) => {
      if (obj?.hasOwnProperty(prd.category)) {
        obj[prd.category].push(prd);
      } else {
        obj[prd.category] = [prd];
      }

      return obj;
    }, {});
    let newCategories = Object.entries(newObject).map(([title, prods]) => {
      return { title, prods };
    });
    setCategories(newCategories);
  }, [products]);
  useEffect(() => {
    setUserList(alluser);
  }, []);

  // **************
  //   final values
  // **************

  const value = {
    // theme
    isDark,
    setIsDark,
    // product infos
    products,
    setProducts,
    // user info
    userList,
    setUserList,
    // order info
    orderList,
    setOrderList,

    // review info
    reviewList,
    setReviewList,

    // checkout info
    checkoutData,
    setCheckoutData,

    // category
    categories,
    isloading,
    setIsLoading,

    // SEO meta tag info
    metaInfo,
    setMetaInfo,
  };
  return <SiteContext.Provider value={value}>{children}</SiteContext.Provider>;
};
